import { RptOpportunityDto, RptOpportunitySearchDto } from '@api/client';
import { createReducer } from '@reduxjs/toolkit';
import { saveFiltersOpportunitiesUsed, searchOpportunities } from './actions';

interface InitialState {
  opportunities: RptOpportunityDto[];
  filtersUsed: RptOpportunitySearchDto | undefined;
  paging: {
    page: number | undefined;
    size: number | undefined;
    totalElements: number | undefined;
    totalPages: number | undefined;
  };
}

const initialState: InitialState = {
  opportunities: [],
  filtersUsed: undefined,
  paging: {
    page: undefined,
    size: undefined,
    totalElements: undefined,
    totalPages: undefined,
  },
};

export const opportunitiesReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(searchOpportunities.fulfilled, (state, action) => {
      state.opportunities = action.payload?.content || [];
      state.paging = {
        page: action.payload?.page,
        size: action.payload?.size,
        totalElements: action.payload?.totalElements,
        totalPages: action.payload?.totalPages,
      };
    })
    .addCase(saveFiltersOpportunitiesUsed, (state, action) => {
      state.filtersUsed = action.payload;
    });
});
